import { render, staticRenderFns } from "./CoursesAdmin.vue?vue&type=template&id=a4c099fe"
import script from "./CoursesAdmin.vue?vue&type=script&lang=js"
export * from "./CoursesAdmin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports